import React, { Component } from 'react'

import './AdListRow.css'

import AdThumbnail from '../AdThumbnail/AdThumbnail'

export default class AdListRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageSrc : props.imageSrc,
            title : props.title,
            beingTouched: false
        }
    }


    onTouchStart = (event) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                beingTouched: true
            }
        });
    }

    onTouchEnd = (event) => {

        this.setState((prevState) => {
            return {
                ...prevState,
                beingTouched: false
            }
        });
    }

    render() {
        return (
            <div 
                className={`ad-list-row-container ${this.state.beingTouched ? 'item-selected' : ''}`}
                onClick={ this.props.onClick } 
                onTouchStart={this.onTouchStart}
                onTouchEnd={this.onTouchEnd}>
                <ul>
                    <li>
                        <AdThumbnail 
                            src={ this.state.imageSrc } 
                            customStyle={{'display': 'inline-block'}}></AdThumbnail>
                    </li>
                    <li className="title-container">
                        <div className="ad-list-row-title">
                            { this.state.title }
                        </div>
                    </li>
                </ul>
             </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/PresentaionAdList/AdListRow/AdListRow.jsx